<div class="screen">

  <!-- ── Résumé global ── -->
  <div class="summary-card">
    <div class="summary-left">
      <span class="summary-avg">{{ globalNote() }}</span>
      <div class="summary-stars">
        @for (s of [1,2,3,4]; track s) {
          <svg width="13" height="13" viewBox="0 0 24 24" fill="#F59E0B"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>
        }
        <svg width="13" height="13" viewBox="0 0 24 24" fill="#E5E7EB"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>
      </div>
      <span class="summary-count">{{ 'mobileSimulator.satisfaction.totalReviewsNetwork' | translate: { count: totalAvis() } }}</span>
    </div>
    <div class="summary-bars">
      @for (n of [5,4,3,2,1]; track n; let i = $index) {
        <div class="bar-row">
          <span class="bar-label">{{ n }}</span>
          <div class="bar-track">
            <div class="bar-fill"
              [style.width.%]="globalRepartition()[i]"
              [attr.data-note]="n >= 4 ? 'good' : n === 3 ? 'mid' : 'bad'">
            </div>
          </div>
          <span class="bar-pct">{{ globalRepartition()[i] }}%</span>
        </div>
      }
    </div>
  </div>

  <!-- ── Filtres période ── -->
  <div class="period-row">
    @for (p of periodes; track p.key) {
      <button class="period-chip" [class.period-chip--active]="periode() === p.key" (click)="periode.set(p.key)">
        {{ p.label }}
      </button>
    }
  </div>

  <!-- ── Comparaison multi-sites ── -->
  <p class="section-title">{{ 'mobileSimulator.satisfaction.comparisonTitle' | translate }}</p>

  <div class="sites-list">
    @for (s of sites(); track s.id; let i = $index) {
      <div class="site-row">

        <div class="site-rank">{{ i + 1 }}</div>

        <div class="site-main">
          <div class="site-top">
            <span class="site-nom">{{ s.nom }}</span>
            <div class="site-trend" [attr.data-trend]="s.trend">
              @if (s.trend === 'up') {
                <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M7 14l5-5 5 5z"/></svg>
                <span>+{{ s.trendVal.toFixed(1) }}</span>
              } @else if (s.trend === 'down') {
                <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg>
                <span>{{ s.trendVal.toFixed(1) }}</span>
              } @else {
                <span>{{ 'mobileSimulator.satisfaction.trendStable' | translate }}</span>
              }
            </div>
          </div>
          <div class="site-bar-row">
            <div class="site-score-bar">
              <div class="site-score-fill"
                [style.width.%]="s.note / 5 * 100"
                [style.background]="noteColor(s.note)">
              </div>
            </div>
            <span class="site-note" [style.color]="noteColor(s.note)">{{ s.note.toFixed(1) }}</span>
          </div>
          <span class="site-avis">{{ 'mobileSimulator.satisfaction.reviewsCount' | translate: { count: s.avis } }}</span>
        </div>

      </div>
    }
  </div>


</div>